import { render, staticRenderFns } from "./GuestList.vue?vue&type=template&id=0179a127&scoped=true&"
import script from "./GuestList.vue?vue&type=script&lang=js&"
export * from "./GuestList.vue?vue&type=script&lang=js&"
import style0 from "./GuestList.vue?vue&type=style&index=0&id=0179a127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179a127",
  null
  
)

export default component.exports